'use strict';

import { Entity } from '../Entity';

export class UserOffice extends Entity {
  protected officeId;

  protected user;

  protected officeName;

  protected officeAddress1;

  protected officeAddress2;

  protected officeCity;

  protected officeState;

  protected officeZip;

  protected officePhone1;

  protected officePhone1Type;

  protected officePhone2;

  protected officePhone2Type;

  protected officeEmail1;

  protected officeEmail2;

  protected officeFax;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.officeId = data.officeId;

    this.user = data.user;

    this.officeName = data.officeName;

    this.officeAddress1 = data.officeAddress1;

    this.officeAddress2 = data.officeAddress2;

    this.officeCity = data.officeCity;

    this.officeState = data.officeState;

    this.officeZip = data.officeZip;

    this.officePhone1 = data.officePhone1;

    this.officePhone1Type = data.officePhone1Type;

    this.officePhone2 = data.officePhone2;

    this.officePhone2Type = data.officePhone2Type;

    this.officeEmail1 = data.officeEmail1;

    this.officeEmail2 = data.officeEmail2;

    this.officeFax = data.officeFax;
  }

  public getOfficeId() {
    return this.officeId;
  }

  public setOfficeId(officeId) {
    this.officeId = officeId;

    return this;
  }

  public getUser() {
    return this.user;
  }

  public setUser(user) {
    this.user = user;

    return this;
  }

  public getOfficeName() {
    return this.officeName;
  }

  public setOfficeName(officeName) {
    this.officeName = officeName;

    return this;
  }

  public getOfficeAddress1() {
    return this.officeAddress1;
  }

  public setOfficeAddress1(officeAddress1) {
    this.officeAddress1 = officeAddress1;

    return this;
  }

  public getOfficeAddress2() {
    return this.officeAddress2;
  }

  public setOfficeAddress2(officeAddress2) {
    this.officeAddress2 = officeAddress2;

    return this;
  }

  public getOfficeCity() {
    return this.officeCity;
  }

  public setOfficeCity(officeCity) {
    this.officeCity = officeCity;

    return this;
  }

  public getOfficeState() {
    return this.officeState;
  }

  public setOfficeState(officeState) {
    this.officeState = officeState;

    return this;
  }

  public getOfficeZip() {
    return this.officeZip;
  }

  public setOfficeZip(officeZip) {
    this.officeZip = officeZip;

    return this;
  }

  public getOfficePhone1() {
    return this.officePhone1;
  }

  public setOfficePhone1(officePhone1) {
    this.officePhone1 = officePhone1;

    return this;
  }

  public getOfficePhone1Type() {
    return this.officePhone1Type;
  }

  public setOfficePhone1Type(officePhone1Type) {
    this.officePhone1Type = officePhone1Type;

    return this;
  }

  public getOfficePhone2() {
    return this.officePhone2;
  }

  public setOfficePhone2(officePhone2) {
    this.officePhone2 = officePhone2;

    return this;
  }

  public getOfficePhone2Type() {
    return this.officePhone2Type;
  }

  public setOfficePhone2Type(officePhone2Type) {
    this.officePhone2Type = officePhone2Type;

    return this;
  }

  public getOfficeEmail1() {
    return this.officeEmail1;
  }

  public setOfficeEmail1(officeEmail1) {
    this.officeEmail1 = officeEmail1;

    return this;
  }

  public getOfficeEmail2() {
    return this.officeEmail2;
  }

  public setOfficeEmail2(officeEmail2) {
    this.officeEmail2 = officeEmail2;

    return this;
  }

  public getOfficeFax() {
    return this.officeFax;
  }

  public setOfficeFax(officeFax) {
    this.officeFax = officeFax;

    return this;
  }
}
